<ee-help-article [slug]="slug" (back)="goHome()"></ee-help-article>
